import React, { FC } from 'react';
import styled from '@emotion/styled';
import { IEnrichedProduct } from '$models';
import { BookDetails } from './components/book-details';
import { NonBookDetails } from './components/non-book-details';

type Props = {
    product: IEnrichedProduct;
};

export const Details: FC<Props> = ({ product: selectedProduct }): JSX.Element => {
    const { product, series, persons } = selectedProduct;
    return (
        <ContentContainer>
            {product?.isBook ? (
                <BookDetails product={product} series={series} persons={persons} />
            ) : (
                <NonBookDetails product={product} series={series} />
            )}
        </ContentContainer>
    );
};

const ContentContainer = styled.div({
    width: '100%',
});
